<template>
	<div id="index" ref="appRef">
		<div class="bg">
			<dv-loading v-if="loading">Loading...</dv-loading>
			<div v-else class="host-body"  id="pushbtnbox">
				<Header @getTime="getTime" />
				<div class="pushbtn" style=" position: absolute;top:0.84rem;left:57%">
					<el-button type="primary" v-if="!inpause" @click="pocBtn">暂停</el-button>
					<el-button type="primary" v-if="inpause" @click="pocBtn">继续</el-button>
				</div>
				<div class="patent">
					<div class="patent_left">
						<create ref="createLeft" />
						<live ref="liveLeft" />
						<apply ref="applyLeft" />
					</div>
					<div class="patent_center">
						<mapCharts ref="map" />
						<protect ref="protectCenter" />
					</div>
					<div class="patent_right">
						<manage @toManageDetail="toManageDetail" ref="manageRight" />
						<service @toManageDetail="toManageDetail" ref="serviceRight" />
					</div>
				</div>
			</div>
			
		</div>
		<!-- 奖项详情 -->
		<div class="dialog_bg" v-if="isPrizeShow">
			<div class="close" @click="isPrizeShow = false">
				<i class="el-icon-close"></i>
			</div>
			<div class="prizeList">
				<div class="prizeItem" v-for="(item,index) in prizeList" :key="index">
					<img src="@/assets/patent/jin.png" alt="" v-if="item.iconType == 1">
					<img src="@/assets/patent/yin.png" alt="" v-if="item.iconType == 2">
					<div class="prizeItem_text">
						<div>{{item.zlmq}}</div>
						<div>{{item.zlqr}}</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 示范城市等详情弹框 -->
		<div class="dialog_bg" v-if="isCityShow">
			<div class="dialog_title">{{dialogTitle}}</div>
			<div class="close" @click="isCityShow = false">
				<i class="el-icon-close"></i>
			</div>
			<div class="dialog_patent_content">
				<div class="dialogItem" v-for="(item,index) in childList" :key="index">
					{{item}}
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	import "@/assets/scss/patent.scss";
	import "@/assets/scss/frame.scss";
	import Header from './header'
	import drawMixin from "../utils/drawMixin";
	import create from "./patent/create.vue";
	import live from "./patent/live.vue";
	import mapCharts from "./patent/map.vue";
	import manage from './patent/manage.vue'
	import apply from './patent/apply.vue'
	import protect from './patent/protect.vue'
	import service from './patent/service.vue'
	import {getPageOneData} from '@/utils/api.js'
	export default {
		mixins: [drawMixin],
		data() {
			return {
				loading: true, //加载状态
				isCityShow: false, //示范城市等弹框
				dialogTitle: '',
				childList: [],
				isPrizeShow: false, //奖项弹框
				prizeList: [],
				isLeave: false, //定义变量判断是否还停留在当前此页面中
				timer:'', //定时器
				inpause:false, // 是否继续
			};
		},
		components: {
			Header,
			create,
			live,
			manage,
			apply,
			protect,
			service,
			mapCharts,
		},
		mounted() {
			this.timer = setTimeout(() =>{
				if(this && !this._isDestroyed){ //_isDestroyed 组件是否被销毁
					console.log(1,'无')
					this.$router.push('/two');
					// return;
				}else{
					console.log(1,'已销毁')
				}
			},30000)
			this.cancelLoading();
			document.querySelector('body').setAttribute('style', 'background-color:#241843;')
		},
		beforeDestroy() {
			document.querySelector('body').setAttribute('style', 'background-color:#020308;')
		},
		methods: {
			// 获取年月
			getTime(val) {
				var params = {
					year: val.year,
					month: val.mon,
				}
				getPageOneData(params).then(res => {
					if (res.status == 200) {
						this.$refs.createLeft.getData(res.data.cz_ipc);
						this.$refs.liveLeft.getData(res.data.cz_ipc);
						this.$refs.applyLeft.getData(res.data.yy, res.data.yy_list);
						this.$refs.map.getData(res.data.map_list);
						this.$refs.protectCenter.getData(res.data.bh, res.data.bh_list);
						this.$refs.manageRight.getData(res.data.gl_gj, res.data.gl_sj);
						this.$refs.serviceRight.getData(res.data.fw_list);
						this.chinaPrizeList = res.data.gl_gj_list // 中国专利奖
						this.ahPrizeList = res.data.gl_sj_list // 安徽省专利奖
					}
				}).catch(err => {
					console.log(err)
				})
			},
			// 管理详情弹框
			toManageDetail(type, data) {
				var that = this
				that.prizeList = []
				if (type == 1) { //奖项详情
					this.isPrizeShow = true
					this.isCityShow = false
					// console.log(data)
					if (data.classify == 'zg') { //中国数据
						// console.log(11,that.chinaPrizeList)
						for (var i in that.chinaPrizeList) {
							if (that.chinaPrizeList[i].type == data.title) {
								that.chinaPrizeList[i].iconType = data.type
								that.prizeList.push(that.chinaPrizeList[i])
							}
						}
					} else if (data.classify == 'ah') { //安徽数据
						for (var j in that.ahPrizeList) {
							if (that.ahPrizeList[j].type == data.title) {
								that.ahPrizeList[j].iconType = data.type
								that.prizeList.push(that.ahPrizeList[j])
							}
						}
					}
				} else { //示范城市等详情
					this.isCityShow = true
					this.isPrizeShow = false
					this.dialogTitle = data.name
					this.childList = data.childs
				}
			},
			// 加载中
			cancelLoading() {
				setTimeout(() => {
					this.loading = false;
				}, 500);
			},
			pocBtn(){
				this.inpause = !this.inpause;
				console.log(this.inpause)
				if(this.inpause){
					console.log("cleartimeout")
					clearTimeout(this.timer);
				}else{
					this.timer = setTimeout(() =>{
						if(this && !this._isDestroyed){ //_isDestroyed 组件是否被销毁
							console.log(1,'无')
							this.$router.push('/two');
							// return;
						}else{
							console.log(1,'已销毁')
						}
					},30000)
				}
			}
		},
	};
</script>
<style lang="scss" scoped>
	.bg {
		background-image: url("../assets/one.jpg");
	}
</style>
